import { render, staticRenderFns } from "./ProductFeatures.vue?vue&type=template&id=1799f03e&scoped=true"
import script from "./ProductFeatures.vue?vue&type=script&lang=js"
export * from "./ProductFeatures.vue?vue&type=script&lang=js"
import style0 from "./ProductFeatures.vue?vue&type=style&index=0&id=1799f03e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1799f03e",
  null
  
)

export default component.exports